<script>
import updateForm from "@wielink-application/shared/js/mixins/updateForm";
import App from "@/pages/layouts/app.vue";
import Form from "@/pages/tester_types/_form.vue";

export default {
	components: {Form, App},
	mixins: [updateForm],
	props: {
		productTesterTypeId: {
			required: true
		}
	},
	data() {
		return {
			formRoute: route('api.v1.products.tester_types.update', {productTesterType: this.productTesterTypeId}),
			redirectRoute: route('tester_types.index'),
			productTesterType: {}
		}
	},

	mounted() {
		this.getProductTesterType();
	},

	methods: {
		getProductTesterType() {
			this.loading = true;
			$.ajax({
				url: route('api.v1.products.tester_types.show', {productTesterType: this.productTesterTypeId}),
				success: (response) => {
					this.productTesterType = response.data;
					this.$refs.form.setProductTesterType(this.productTesterType);
				}
			}).always(() => {
				this.loading = false;
			})
		},

		afterSuccess() {
			this.getProductTesterType();
		},
	}
}
</script>

<template>
	<App title="Meetmiddel bewerken">
		<form class="mb-4" @submit.prevent="submit" id="tester_type_form">
			<Form ref="form"/>
		</form>

		<template #bottomButtons>
			<FormButtons
				:cancelRoute="redirectRoute"
				@backToOverview="stayOnPage = 0"
				form-id="tester_type_form"
				:loading="loading"
			/>
		</template>
	</App>
</template>